import styled from 'styled-components'
import {
  COLOR,
  BUTTON_SIZE,
  FONT_SIZE
} from '../../themes'
export const BUTTON = styled.button`
    float: left;
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    background: ${COLOR.BLACK_1};
    color: ${COLOR.WHITE};
    cursor: pointer;
    text-align: center;
    border-radius: 4px;
    font-size: ${FONT_SIZE.XS};
    outline: none;

    &.is-ui-disabled {
    cursor: not-allowed !important;
    color:${COLOR.WHITE} !important;
    border-color:${COLOR.WHITE} !important;
    }
    .icon-btn{
      vertical-align: text-top;
      padding-right: 10px;
    }
    .round {
      border-radius: 50%;
    }
`
